const PRICE = {
  CREDIT_REPORT: {
    // - RentSpree Pre-login
    'pre-login': 39.99,
    // - Other Partners
    'apartmentlist': 38
  },
  INCOME_VERI: {
    'pre-login': 10
  }
}

export default PRICE
